/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FleetYards.net Command API
 * OpenAPI spec version: v1
 */
import {
  useMutation,
  useQuery
} from '@tanstack/vue-query';
import type {
  DataTag,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UseMutationOptions,
  UseMutationReturnType,
  UseQueryOptions,
  UseQueryReturnType
} from '@tanstack/vue-query';

import {
  toValue,
  unref
} from 'vue';
import type {
  MaybeRefOrGetter
} from 'vue';

import type {
  Image,
  ImageInput,
  ImageInputCreate,
  ImageUpdateBulkInput,
  Images,
  ImagesParams,
  SchemaValidationErrorResponse,
  StandardError
} from '../../models';

import { axiosClient } from '../../../axiosAdminClient.ts';
import type { ErrorType } from '../../../axiosAdminClient.ts';




/**
 * @summary Image create
 */
export const createImage = (
    imageInputCreate?: MaybeRefOrGetter<ImageInputCreate>,
 signal?: AbortSignal
) => {
      imageInputCreate = toValue(imageInputCreate);

      return axiosClient<Image>(
      {url: `/images`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: imageInputCreate, signal
    },
      );
    }




export const getCreateImageMutationOptions = <TError = ErrorType<SchemaValidationErrorResponse | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createImage>>, TError,{data?: ImageInputCreate}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof createImage>>, TError,{data?: ImageInputCreate}, TContext> => {

const mutationKey = ['createImage'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createImage>>, {data?: ImageInputCreate}> = (props) => {
          const {data} = props ?? {};

          return  createImage(data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateImageMutationResult = NonNullable<Awaited<ReturnType<typeof createImage>>>
    export type CreateImageMutationBody = ImageInputCreate | undefined
    export type CreateImageMutationError = ErrorType<SchemaValidationErrorResponse | StandardError>

    /**
 * @summary Image create
 */
export const useCreateImage = <TError = ErrorType<SchemaValidationErrorResponse | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createImage>>, TError,{data?: ImageInputCreate}, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof createImage>>,
        TError,
        {data?: ImageInputCreate},
        TContext
      > => {
      return useMutation(getCreateImageMutationOptions(options), queryClient);
    }
    /**
 * Get a List of Images
 * @summary Images list
 */
export const images = (
    params?: MaybeRefOrGetter<ImagesParams>,
 signal?: AbortSignal
) => {
      params = toValue(params);

      return axiosClient<Images>(
      {url: `/images`, method: 'GET',
        params, signal
    },
      );
    }




export const getImagesQueryKey = (params?: MaybeRefOrGetter<ImagesParams>,) => {
    return [
    'images', ...(params ? [params] : [])
    ] as const;
    }


export const getImagesQueryOptions = <TData = Awaited<ReturnType<typeof images>>, TError = ErrorType<SchemaValidationErrorResponse | StandardError>>(params?: MaybeRefOrGetter<ImagesParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof images>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getImagesQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof images>>> = ({ signal }) => images(params, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof images>>, TError, TData>
}

export type ImagesQueryResult = NonNullable<Awaited<ReturnType<typeof images>>>
export type ImagesQueryError = ErrorType<SchemaValidationErrorResponse | StandardError>


/**
 * @summary Images list
 */

export function useImages<TData = Awaited<ReturnType<typeof images>>, TError = ErrorType<SchemaValidationErrorResponse | StandardError>>(
 params?: MaybeRefOrGetter<ImagesParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof images>>, TError, TData>>, }
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getImagesQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}






/**
 * @summary Bulk update images
 */
export const updateBulkImage = (
    imageUpdateBulkInput: MaybeRefOrGetter<ImageUpdateBulkInput>,
 signal?: AbortSignal
) => {
      imageUpdateBulkInput = toValue(imageUpdateBulkInput);

      return axiosClient<void>(
      {url: `/images/bulk`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: imageUpdateBulkInput, signal
    },
      );
    }




export const getUpdateBulkImageMutationOptions = <TError = ErrorType<SchemaValidationErrorResponse | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateBulkImage>>, TError,{data: ImageUpdateBulkInput}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof updateBulkImage>>, TError,{data: ImageUpdateBulkInput}, TContext> => {

const mutationKey = ['updateBulkImage'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateBulkImage>>, {data: ImageUpdateBulkInput}> = (props) => {
          const {data} = props ?? {};

          return  updateBulkImage(data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateBulkImageMutationResult = NonNullable<Awaited<ReturnType<typeof updateBulkImage>>>
    export type UpdateBulkImageMutationBody = ImageUpdateBulkInput
    export type UpdateBulkImageMutationError = ErrorType<SchemaValidationErrorResponse | StandardError>

    /**
 * @summary Bulk update images
 */
export const useUpdateBulkImage = <TError = ErrorType<SchemaValidationErrorResponse | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateBulkImage>>, TError,{data: ImageUpdateBulkInput}, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof updateBulkImage>>,
        TError,
        {data: ImageUpdateBulkInput},
        TContext
      > => {
      return useMutation(getUpdateBulkImageMutationOptions(options), queryClient);
    }
    /**
 * @summary Image destroy
 */
export const destroyImage = (
    id: MaybeRefOrGetter<string>,
 signal?: AbortSignal
) => {
      id = toValue(id);

      return axiosClient<void>(
      {url: `/images/${id}`, method: 'DELETE', signal
    },
      );
    }




export const getDestroyImageMutationOptions = <TError = ErrorType<SchemaValidationErrorResponse | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof destroyImage>>, TError,{id: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof destroyImage>>, TError,{id: string}, TContext> => {

const mutationKey = ['destroyImage'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof destroyImage>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  destroyImage(id,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DestroyImageMutationResult = NonNullable<Awaited<ReturnType<typeof destroyImage>>>

    export type DestroyImageMutationError = ErrorType<SchemaValidationErrorResponse | StandardError>

    /**
 * @summary Image destroy
 */
export const useDestroyImage = <TError = ErrorType<SchemaValidationErrorResponse | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof destroyImage>>, TError,{id: string}, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof destroyImage>>,
        TError,
        {id: string},
        TContext
      > => {
      return useMutation(getDestroyImageMutationOptions(options), queryClient);
    }
    /**
 * @summary Image update
 */
export const updateImage = (
    id: MaybeRefOrGetter<string>,
    imageInput?: MaybeRefOrGetter<ImageInput>,
 signal?: AbortSignal
) => {
      id = toValue(id);
imageInput = toValue(imageInput);

      return axiosClient<Image>(
      {url: `/images/${id}`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: imageInput, signal
    },
      );
    }




export const getUpdateImageMutationOptions = <TError = ErrorType<SchemaValidationErrorResponse | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateImage>>, TError,{id: string;data?: ImageInput}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof updateImage>>, TError,{id: string;data?: ImageInput}, TContext> => {

const mutationKey = ['updateImage'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateImage>>, {id: string;data?: ImageInput}> = (props) => {
          const {id,data} = props ?? {};

          return  updateImage(id,data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateImageMutationResult = NonNullable<Awaited<ReturnType<typeof updateImage>>>
    export type UpdateImageMutationBody = ImageInput | undefined
    export type UpdateImageMutationError = ErrorType<SchemaValidationErrorResponse | StandardError>

    /**
 * @summary Image update
 */
export const useUpdateImage = <TError = ErrorType<SchemaValidationErrorResponse | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateImage>>, TError,{id: string;data?: ImageInput}, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof updateImage>>,
        TError,
        {id: string;data?: ImageInput},
        TContext
      > => {
      return useMutation(getUpdateImageMutationOptions(options), queryClient);
    }
